/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Building } from './building.model';
import { Parcel } from './parcel.model';


export interface RightToBuild { 
    building?: Building;
    datumPrijeti?: string;
    datumUkonceni?: string;
    endDate?: string;
    id?: number;
    katuzeKod?: number;
    katuzeNazev?: string;
    lv?: number;
    parcel?: Parcel;
    psId?: number;
    startDate?: string;
}

